
import { useState } from "react";
import { Message } from "@/types/message";
import { useMessageGrouping, findLatestAIMessage } from "./useMessageGrouping";

interface UseMessageListProps {
  messages: Message[];
  isAIGenerating?: boolean;
}

export const useMessageList = ({ 
  messages, 
  isAIGenerating = false 
}: UseMessageListProps) => {
  // Group messages by thread for UI purposes
  const groupedThreads = useMessageGrouping(messages);
  
  // State to track which threads are expanded 
  const [expandedThreads, setExpandedThreads] = useState<Record<string, boolean>>({});
  
  // Toggling thread expansion
  const toggleThread = (threadId: string) => {
    setExpandedThreads(prev => ({
      ...prev,
      [threadId]: !prev[threadId]
    }));
  };
  
  // Find the latest AI message for specialized handling
  const latestAIMessage = findLatestAIMessage(messages);
  
  const hasMessages = messages.length > 0;

  return {
    groupedThreads,
    latestAIMessage,
    hasMessages,
    expandedThreads,
    toggleThread
  };
};
